import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-info-confirmation',
  templateUrl: './info-confirmation.component.html',
  styleUrls: ['./info-confirmation.component.scss'],
})
export class InfoConfirmationComponent implements OnInit {

  @Input() inputMessage;
  @Input() changeButtonStyle: any = false;
  @Input() title;

  constructor(private modalCtrl: ModalController) { }

  ngOnInit() { }

  confirm() {
    this.modalCtrl.dismiss({ type: 'confirm' });
  }

}
